import React from 'react';
import { Row, Col, FormGroup, Label } from 'reactstrap';
import PracticeProfileFields from '../../../../Practices/PracticeProfileFields';
import { UserSummaryPracticeDTO } from '../../../../Practices/practiceDataMapper';

interface PMGAffiliation {
    groupName?: string;
}

interface AssociateMember {
    memberName: string;
    role: string;
}

interface PracticeAffiliationAndMembersProps {
    practice: UserSummaryPracticeDTO & {
        groupAffiliation?: PMGAffiliation;
        associateMembers?: AssociateMember[];
    };
}

const PracticeAffiliationAndMembers: React.FC<
    PracticeAffiliationAndMembersProps
> = ({ practice }) => {
    const renderPmgAffiliation = () => (
        <FormGroup>
            <Label for="pmgAffiliation">PMG Affiliation</Label>
            <h6>{practice.groupAffiliation?.groupName ?? 'NA'}</h6>
        </FormGroup>
    );

    const renderMemberList = () => {
        const members = practice.associateMembers ?? [];
        return members.length > 0 ? (
            <FormGroup>
                {members.map((member, index) => (
                    <p key={index}>
                        <h6>
                            {member.memberName} – {member.role}
                        </h6>
                    </p>
                ))}
            </FormGroup>
        ) : (
            <h6>NA</h6>
        );
    };

    return (
        <>
            <Row>
                <Col md={4}>{renderPmgAffiliation()}</Col>
                <Col md={2}>
                    <Label for="associateMember">Team Members</Label>
                </Col>
                <Col md={6}>{renderMemberList()}</Col>
            </Row>
            <PracticeProfileFields practice={practice} />
        </>
    );
};

export default PracticeAffiliationAndMembers;
